import React, { useState } from "react";
import { getImg } from "../../assets/getImg";
import "./index.css";
const tab = [
  {
    label: "首页",
    value: 0,
    url: "http://www.chinakidney.net/index.php/welcome.html",
  },
  {
    label: "关于我们",
    value: 1,
    url: "http://www.chinakidney.net/index.php/about.html",
  },
  {
    label: "数据资源",
    value: 2,
    url: "http://www.chinakidney.net/index.php/data.html",
  },
  {
    label: "成果",
    value: 3,
    url: "http://www.chinakidney.net/index.php/achievement.html",
  },
  {
    label: "大事记",
    value: 4,
    url: "http://www.chinakidney.net/index.php/news.html",
  },
  {
    label: "联系我们",
    value: 5,
    url: "http://www.chinakidney.net/index.php/contact.html",
  },
];

export default function Head(props) {
  const [active, setActive] = useState(3);
  const [, setChecked] = useState("en"); // en  ch
  const [tabHover, setTabHover] = useState(() => {
    const res = {};
    tab.map((item) => {
      res[item.value] = false;
    });
    return res;
  });

  function handleMouseOver(item) {
    console.log("handleMouseOver", item);
    setTabHover((prev) => {
      const tem = { ...prev };
      tem[item.value] = true;
      return tem;
    });
  }

  function handleMouseOut(item) {
    // console.log("handleMouseOut", item);
    setTabHover((prev) => {
      const tem = { ...prev };
      tem[item.value] = false;
      return tem;
    });
  }

  function renderTabItem({ label, value, url }) {
    return (
      <a href={url}>
        <div
          onMouseOver={() => {
            handleMouseOver({ label, value });
          }}
          onMouseOut={() => {
            handleMouseOut({ label, value });
          }}
          className="zhyl_ckd_head_right_tap_item"
          key={value}
          onClick={(_) => {
            setActive(value);
          }}
        >
          <span className="zhyl_ckd_head_right_tap_item_label">{label}</span>
          <div
            className={
              tabHover[value] || active === value
                ? "zhyl_ckd_head_right_tap_item_line_over"
                : "zhyl_ckd_head_right_tap_item_line_out"
            }
          ></div>
        </div>
      </a>
    );
  }

  function onChange(checked) {
    setChecked((prev) => {
      if (prev === "en") {
        return "ch";
      } else {
        return "en";
      }
    });
  }

  return (
    <div className="zhyl_ckd_head">
      <div className="zhyl_ckd_head_w">
        <div className="zhyl_ckd_head_left">
          <img className="zhyl_ckd_head_left_img" src={getImg("log2x")} />
          <p className="zhyl_ckd_head_left_txt1">CK-NET</p>
          <div className="zhyl_ckd_head_left_txt2_wrap">
            <span className="zhyl_ckd_head_left_txt2_wrap_txt1">
              肾脏疾病数据网络
            </span>
            <span className="zhyl_ckd_head_left_txt2_wrap_txt2">
              <span style={{ color: "#6CA6CD" }}>C</span>hina{" "}
              <span style={{ color: "#6CA6CD" }}>K</span>idney Disease{" "}
              <span style={{ color: "#6CA6CD" }}>Net</span>work
            </span>
          </div>
        </div>
        <div className="zhyl_ckd_head_right">
          <div className="zhyl_ckd_head_right_tap">
            {tab.map((item) => {
              return renderTabItem(item);
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
